import React, { FunctionComponent } from "react"
import { FilterType } from "@murphy-frontend/web-core/components/FilterControl"
import FilterToggleRow from "./FilterToggleRow"

interface FiltersRowProps {
	selectedTabId: number
	isUserView: boolean
	userFilters: FilterType[]
	educationByUserFilters: FilterType[]
	educationByCourseFilters: FilterType[]
	onToggleFilter: (filter: FilterType, filterName: string) => void
}

const FiltersRow: FunctionComponent<FiltersRowProps> = ({
	selectedTabId,
	isUserView,
	userFilters,
	educationByUserFilters,
	educationByCourseFilters,
	onToggleFilter
}) => {
	return (
		<section className='filters-container-general'>
			{selectedTabId === 0 &&
				userFilters.map(filter => (
					<FilterToggleRow
						filter={filter}
						onToggleFilter={onToggleFilter}
						key={filter.displayName}
						filterName='user'
					/>
				))}
			{selectedTabId === 1 &&
				isUserView &&
				educationByUserFilters.map(filter => (
					<FilterToggleRow
						filter={filter}
						onToggleFilter={onToggleFilter}
						key={filter.displayName}
						filterName='education'
					/>
				))}
			{selectedTabId === 1 &&
				!isUserView &&
				educationByCourseFilters.map(filter => (
					<FilterToggleRow
						filter={filter}
						onToggleFilter={onToggleFilter}
						key={filter.displayName}
						filterName='course'
					/>
				))}
		</section>
	)
}

export default FiltersRow